import { useEffect } from "react";

export function useScrollToTop(delay = 100) {
  useEffect(() => {
    const id = setTimeout(
      () => window.scrollTo({ top: 0, behavior: "smooth" }),
      delay,
    );
    return () => clearTimeout(id);
  }, [delay]);
}
